import stores from "stores/stores";
import * as tts from "tts";

export const needsSpeakingModeVoice = (language: string | undefined): boolean =>
  Boolean(
    language &&
      tts.getVoicePickerState({
        user: stores.user,
        feature: "speakingMode",
        language,
      }).selectedVoiceSource !== "stored"
  );

export const setSpeakingModeWithVoicePrompt = (
  enabled: boolean,
  language: string | undefined,
  afterEnable?: () => void
): void => {
  stores.user.save({ speakingMode: enabled });

  if (!enabled) return;
  if (language && needsSpeakingModeVoice(language)) {
    tts.promptForSpeakingModeVoice(language);
  }
  afterEnable?.();
};
